// production
const config = {
  baseUrl: "https://fleets.cabcard.services",
  apiBaseUrl: "https://api.cabcard.services",
  cookieDomain: ".cabcard.services",
  namespace: "fleets_cabcard-services",
  paymentFacilitatorId: "pfc_3q12hkjyo6478c" // CCS production
};

if (
  [
    "dev.cabcard.services",
    "dev-a.cabcard.services",
    "dev-b.cabcard.services",
    "dev-c.cabcard.services"
  ].includes(window.location.hostname)
) {
  // development
  config.baseUrl = `http://${window.location.host}`;
  config.apiBaseUrl = "https://api-staging.cabcard.services";
  // remove subdomain from cookieDomain
  config.cookieDomain = window.location.hostname.replace( /[^\.]*\./ , "." );
  config.namespace = "fleets-dev_cabcard-services";
  config.paymentFacilitatorId = "pfc_bsu0fikjxyxvu2u"; // staging

  // Keep getting logged out? check baseUrl and cookieDomain
} else if (window.location.hostname === "fleets-staging.cabcard.services") {
  // staging
  config.baseUrl = "https://fleets-staging.cabcard.services";
  config.apiBaseUrl = "https://api-staging.optimusgateway.com";
  config.cookieDomain = ".cabcard.services";
  config.namespace = "fleets-stg_cabcard-services";
  config.paymentFacilitatorId = "pfc_bsu0fikjxyxvu2u"; // staging
} else if (window.location.hostname === "fleets-sandbox.cabcard.services") {
  // sandbox
  config.baseUrl = "https://fleets-sandbox.cabcard.services";
  config.apiBaseUrl = "https://api-sandbox.optimusgateway.com";
  config.cookieDomain = ".cabcard.services";
  config.namespace = "fleets-sbx_cabcard-services";
  config.paymentFacilitatorId = "pfc_hdjjjenxke8379";
}

export default config;
